import { Component, inject } from '@angular/core';
import { SoftwareSpecificSearchService } from '../../software-specific-search.service';

@Component({
    selector: 'app-software-terms-use-popup',
    templateUrl: './software-terms-use-popup.component.html',
    styleUrls: ['../soft-ware-request-form-page.component.scss'],
    standalone: false
})
export class SoftwareTermsUsePopupComponent {
  public service = inject(SoftwareSpecificSearchService);
}
